import projects from './projects';

export default {
  projects
};
